import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { allProductGroupsAtom } from '../../../api/masters.atoms'
import React from 'react'
import { MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { objectFieldSort } from '../../../utility'

export function SelectGroupDropdown({
  onSelect,
  selectedId,
}: {
  selectedId?: number
  onSelect: (id: number) => void
}) {
  const allGroups = useAtomValue(allProductGroupsAtom).sort(
    objectFieldSort('name'),
  )
  const onChange = ({ target: { value } }: SelectChangeEvent<number>) => {
    onSelect(Number(value))
  }
  return (
    <Select value={selectedId} onChange={onChange}>
      {allGroups.map((group) => {
        return (
          <MenuItem key={group.id} value={group.id}>
            {group.name}
          </MenuItem>
        )
      })}
    </Select>
  )
}
